import $ from 'jquery';
import rimg from 'rimg-shopify';
import CurrencyConverter from 'shopify-currency-converter';
import ShopifyVariants from 'shopify-variants';
import ImageZoom from '../utils/ImageZoom';
import Rte from '../utils/Rte';

export default class StaticProduct {
  constructor({
    el,
    data,
    type,
    id,
  }) {
    this.$el = $(el);

    this.sectionType = type;
    this.data = data;
    this.sectionId = id;
    this.product = data.product;
    this.cartText = data.cartText;
    this.zoomEnabled = data.sectionSettings.enable_zoom;
    this.enableSendToCart = data.sectionSettings.enable_send_to_cart;

    this.$options = this.$el.find('[data-product-option]');
    this.$variants = this.$el.find('[data-variants]');
    this.$form = this.$el.find('.product-form form');

    this.timeouts = [];
    this.isThemeEditor = window.Shopify && window.Shopify.designMode;
    this.images = JSON.parse($('[data-images]', this.$el).text());

    this._bindEvents();

    if (this.$form.length) {
      this.variantHelper = new ShopifyVariants(this.product, this.$variants, this.$options);
    }

    if (this.zoomEnabled && $('.product-images', this.$el).length) {
      this.zoomView = new ImageZoom({ el: $('.product-main-image', this.$el) });
    }

    Shopify.onError = XMLHttpRequest => this._handleErrors(XMLHttpRequest);

    this.$el.find('.rte').each((index, rte) => { this.rte = new Rte({ el: rte }); });

    if (Shop.currencySwitcher) {
      $('.currency-switcher').trigger('switch-currency');
    }
  }

  _bindEvents() {
    this.events = [
      this.$el.find('.product-thumbnails img').on(`click.${this.sectionId}`, e => this._onSwapImage(e)),
      this.$el.find('.product-form').on(`submit.${this.sectionId}`, e => this._addToCart(e)),
      $(window).on(`shopify-variants:switch-variant.${this.sectionId}`, (event, data) => {
        this._changeVariant(data);
      }),
    ];
  }

  _unbindEvents() {
    this.events.forEach($el => $el.off(`.${this.sectionId}`));
  }

  _onSwapImage(event) {
    this._swapImage($(event.target).data('image-id'));
  }

  _swapImage(imageId) {
    const $nextImageWrapper = $(this.images[imageId]);
    $nextImageWrapper.css('display', 'none');
    const $nextImages = $nextImageWrapper.find('img');

    const $imageWrapper = $('.product-main-image [data-product-image]', this.$el);
    const $images = $imageWrapper.find('img');

    rimg.unwatch($images[0]);

    $nextImages.one('load', () => {
      $imageWrapper.remove();
      $nextImageWrapper.css('display', '');
      rimg.watch($nextImages[0]);

      if (this.zoomEnabled) {
        const $productMainImage = $('.product-main-image', this.$el);
        $productMainImage.trigger('cancel-zoom');
        $productMainImage.trigger('prepare-zoom');
      }
    });

    $imageWrapper.after($nextImageWrapper);
  }

  _changeVariant({ product, variant, firstLoad }) {
    if (firstLoad || this.product !== product) {
      return;
    }

    // Update URL
    if (this.data.enableHistory) {
      this._changeUrl(variant);
    }

    // Load image
    if (variant.featured_image) {
      this._swapImage(variant.featured_image.id);
    } else if (this.images.defaultImageId) {
      this._swapImage(this.images.defaultImageId);
    }

    // Compare at price
    this.$el.find('[data-variant-compare-at-price]')
      .toggleClass(
        'hidden',
        (
          !variant.compare_at_price
          || variant.price === variant.compare_at_price
        ),
      )
      .text(Shopify.formatMoney(variant.compare_at_price, Shop.moneyFormat))
      .each((index, el) => CurrencyConverter.update(el));

    // Price
    this.$el.find('[data-variant-price]')
      .text(Shopify.formatMoney(variant.price, Shop.moneyFormat))
      .each((index, el) => CurrencyConverter.update(el));
  }

  _changeUrl(variant) {
    if (this.isThemeEditor) {
      return;
    }

    const params = $.param({ variant: variant.id });
    const url = `${ this.product.handle }?${params}`;
    history.replaceState({}, 'variant', url);
  }

  _addToCart(e) {
    e.preventDefault();

    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: this.$form.serialize(),
      dataType: 'json',
    })
      // On success
      .done(() => {

        if (this.enableSendToCart) {
          window.location.href = '/cart';
          return;
        }

        $('.cart-count').addClass('active-cart');

        const message = this.data.message
          .replace('{{ product }}', this.product.title)
          .replace('{{ cart_link }}', `<a href='/cart'>${this.data.cartLink}</a>`)
          .replace('{{ continue_link }}', `<a href='/collections/all'>${this.data.continueLink}</a>`)
          .replace('{{ checkout_link }}', `<a href='/checkout'>${this.data.checkoutLink}</a>`);

        this.timeouts.push(setTimeout(() => {
          this.$el.find('.product-message', this.$el).html(message).addClass('success-message').removeClass('error-message');
          this._updateCart();
        },
        500));
      })
      // On failure
      .fail(response => this._handleErrors(response));
  }

  _updateCart() {
    return Shopify.getCart((cart) => {
      $('.cart-item-count').text(cart.item_count);
      $('.header-tools-cart').addClass('cart-has-content');
    });
  }

  _handleErrors(response) {
    const error = JSON.parse(response.responseText);

    $('.product-form', this.$el).append(`<div class="error-message">${error.description}</div>`);
  }

  onSectionUnload() {
    this._unbindEvents();
    if (this.zoomView) {
      this.zoomView.unload();
    }
    if (this.variantHelper) {
      this.variantHelper.unload();
    }
    this.timeouts.forEach(timeout => clearTimeout(timeout));
  }
}
